import {
    REPORT_FAILED,
    REPORT_FETCHING,
    REPORT_SUCCESS,
    REPORT_FORM_NO_SUCCESS,
    REPORT_DEV5_DASHBOARD_SUCCESS
} from "../../Constants.ts";

export interface ReportState {
    isFetching: boolean;
    isError: boolean;
    result: any;
    formNoResult: any;
    dev5DashboardResult?: any; // Optional for the new dashboard data
}

const initialState: ReportState = {
    isFetching: false,
    isError: false,
    result: null,
    formNoResult: null,
    dev5DashboardResult: null
};

export default (state = initialState, { type, payload }: any): ReportState => {
    switch (type) {
        case REPORT_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case REPORT_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case REPORT_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        case REPORT_FORM_NO_SUCCESS:
            return { ...state, isFetching: false, isError: true, formNoResult: payload };
        case REPORT_DEV5_DASHBOARD_SUCCESS:
            return { ...state, isFetching: false, isError: false, dev5DashboardResult: payload };
        default:
            return state;
    }
};
